import { post } from "helpers/api_helper";
import * as URL from "helpers/url_helper"

export const getApiLogs = data => post(URL.GET_API_LOGS, data);
